<template>
	<v-card>

		<v-card-title class="headline">Cuenta</v-card-title>

		<v-card-text>

			<v-card-subtitle>Cambiar contraseña:</v-card-subtitle>

			<v-text-field
				v-model="datos.contraseña1"
				prepend-icon="mdi-lock-reset"
				type="password"
				minlength="8"
				maxlength="30"
				label="Escriba la nueva contraseña"
				required
			></v-text-field>

			<v-text-field
				v-model="datos.contraseña2"
				prepend-icon="mdi-lock-reset"
				type="password"
				minlength="8"
				maxlength="30"
				label="Confirme la nueva contraseña"
				required
			></v-text-field>

		</v-card-text>

		<v-card-actions>
			<v-spacer></v-spacer>

			<v-btn
				color="grey darken-1"
				text
				:disabled="autenticación.cambiandoContraseña"
				@click="cancelar"
			>
				Cancelar
			</v-btn>

			<v-btn
				color="green darken-1"
				text
				:loading="autenticación.cambiandoContraseña"
				@click="cambiar"
			>
				Cambiar contraseña
			</v-btn>
		</v-card-actions>

		</v-card>
</template>

<script>
import { autenticación } from '@/../../cliente_comun/fuentes'

export default {
	name: 'cuenta',
	data: () => ({
		autenticación: autenticación,
		datos: {
			contraseña1: '',
			contraseña2: ''
		}
	}),
	methods: {
		cambiar: function() {
			this.autenticación.cambiarContraseña(this.datos.contraseña1, this.datos.contraseña2).then(() => {
				this.limpiar()
				this.$emit('guardar')
			})
		},
		cancelar: function() {
			this.limpiar()
			this.$emit('cancelar')
		},
		limpiar: function() {
			this.datos.contraseña1 = ''
			this.datos.contraseña2 = ''
		}
	}
}
</script>